import script from "./icon-close.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-close.vue?vue&type=script&lang=ts&setup=true"

import "./icon-close.vue?vue&type=style&index=0&id=9ba8a4c0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ba8a4c0"]])

export default __exports__